import React from 'react';

const UnreadBadge = ({ count = 0, size = 22, background = '#2563eb', color = '#ffffff', animate = false }) => {
  const style = {
  minWidth: `${size}px`,
  height: `${size}px`,
  background: background,
  color: color,
  fontSize: size <= 16 ? '10px' : size <= 20 ? '11px' : '12px',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontWeight: 700,
  flexShrink: 0,
  padding: '0 2px',
  lineHeight: 1,
  border: '2px solid white',
  animation: animate ? 'badge-pulse 1.5s infinite' : 'none',
};

  const display = count > 99 ? '99+' : String(count);

  return (
    <>
      {animate && (
        <style>
          {`
            @keyframes badge-pulse {
              0% { transform: scale(1); box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.7); }
              70% { transform: scale(1.2); box-shadow: 0 0 0 6px rgba(239, 68, 68, 0); }
              100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(239, 68, 68, 0); }
            }
          `}
        </style>
      )}
      <span style={style} aria-label={`${display} unread`} role="status">
        {display}
      </span>
    </>
  );
};

export default UnreadBadge;
